import type { FigureView, ResolvedFigure, Viewport } from '../model.js';
import { finishFigure, type SceneBuilder } from '../scene-builder.js';

/**
 * Temporary primitive-spike contract. The root registry will promote only the
 * primitives that meet the gallery gate; this keeps experiments out of the
 * lesson-family union while preserving the exact resolved-scene boundary.
 */
export interface PrimitiveSpec {
  id: string;
  family: string;
  view: FigureView;
  viewport: Viewport;
  provenance: string;
  focus?: string;
  emphasis?: string[];
}

export function finishPrimitive(
  spec: PrimitiveSpec,
  builder: SceneBuilder,
  data: { title: string; subtitle: string; state?: string; active?: string[]; warnings?: string[] },
): ResolvedFigure {
  return finishFigure(spec as never, builder, {
    title: data.title,
    subtitle: data.subtitle,
    state: data.state ?? spec.focus ?? 'overview',
    active: data.active ?? [spec.focus && spec.focus !== 'overview' ? spec.focus : spec.family, ...(spec.emphasis ?? [])],
    warnings: data.warnings,
  }) as ResolvedFigure;
}
